<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <!-- 统一60%居中nav毛玻璃容器 -->
    <div class="nav">
      <!-- 模块标题 -->
      <div class="module-title">
        <h1>DR检查技术虚拟仿真系统</h1>
      </div>

      <!-- 主内容卡片 -->
      <div class="ct-content">
        <!-- DR原有文字描述模块 -->
        <div class="text-block">
          <p class="desc-text">{{ p[0] }}</p>
        </div>
        <!-- 步骤图片组件 -->
        <SImgNum :imgList="list" class="step-list" />
      </div>

    </div>
  </div>
</template>

<script>
import SImgNum from "@/components/sImgNum.vue";
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CheckDR",
  components: {
    SImgNum,
    PullDown,
  },
  data() {
    return {
      p: [
        "紧扣《医学影像检查技术学》教学内容，DR检查技术虚拟仿真教学系统具有开机准备、信息录入、检查前准备、摆位、参数调整、曝光、医患沟通、图像处理、评价报告等过程，具有学习模式和考核模式，学习模式具有指导学习功能、考核模式具有自主命题、随机出题等方式。有效解决实体设备数量不足、学生实操轮次有限、放射实训存在辐射风险等问题。",
      ],
      list: [
        { img: require("@/assets/cDR1.png"), text: "登录界面" },
        { img: require("@/assets/cDR2.png"), text: "软件主页" },
        { img: require("@/assets/cDR3.png"), text: "设备开机" },
        { img: require("@/assets/cDR4.png"), text: "预约界面" },
        { img: require("@/assets/cDR5.png"), text: "选择扫描部位" },
        { img: require("@/assets/cDR6.png"), text: "院感防疫" },
        { img: require("@/assets/cDR7.png"), text: "检查申请单" },
        { img: require("@/assets/cDR8.png"), text: "病人防护" },
        { img: require("@/assets/cDR9.png"), text: "调整扫描架" },
        { img: require("@/assets/cDR10.png"), text: "受检者摆位" },
        { img: require("@/assets/cDR11.png"), text: "调整曝光参数" },
        { img: require("@/assets/cDR12.png"), text: "曝光出图" },
      ],
      wWidth: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  // 核心居中毛玻璃容器（与CT设备页面完全一致）
  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }

    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  // 统一标题样式
  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  // 主内容白色卡片
  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
    }

    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
    }

    // DR原有文字区块保留，适配全局字体
    .text-block {
      position: relative;
      padding-left: 14px;
      margin-bottom: 42px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 3px;
        bottom: 3px;
        width: 4px;
        border-radius: 2px;
        background: linear-gradient(180deg, #64b5f6, #1976d2);
      }

      .desc-text {
        margin: 0;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 0.95rem;
        line-height: 1.9;
        color: #223344;
        letter-spacing: 0.5px;
        text-align: justify;

        @media (max-width: 767px) {
          font-size: 0.85rem;
          line-height: 1.8;
        }
      }
    }

    .step-list {
      padding-top: 0;
    }
  }

}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .text-block::before {
          background: linear-gradient(180deg, #5096d1, #1759a1);
        }

        .desc-text {
          color: #c8d6e8;
        }
      }
    }
  }
}

// 全局导航深度样式与CT设备页面保持一致
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>